export const avatar = (user, size) => {
  return `https://github.com/${user.replace('@', '')}.png?size=${size}`;
};

export const url = (user) => {
  return `https://github.com/${user.replace('@', '')}`;
};
